export default function getButtonDescription(facetName, size) {
    return `Btn ${ facetName } (${ size })`;
};
